
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import 'swiper/dist/css/swiper.css';
import { getOptionalList } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
tabIndex: 0,
leftVal: 0,
trade_type:1,
nation: "US",
timerInfo: null,
list: []
}
},
computed:{
...mapState(['token'])
},



created(){
this.trade_type = window.localStorage.getItem('trade_type') || 1
this.SETTOKEN()
this.getData()
},
methods:{
...mapMutations(['SETTOKEN']),
goContract(type, trade_type){
if(trade_type==1){
this.$router.push(`/pages/info?name=BTC&type=${type}`)
}else if(trade_type==2){
this.$router.push(`/pages/info?name=${this.coinList[0].ptitle}&type=${type}&trade_type=2&pid=${this.coinList[0].id}`)
}else{
this.$router.push(`/pages/info?name=${this.coinList[0].name}&type=${type}&trade_type=3&code=${this.coinList[0].symbol}&nation=${nation}`)
}

},
getData(){
var that = this
this.$Loading()
getOptionalList({token: this.token,trade_type: this.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.list = res.data || []
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)

}
}.bind(this),function(){
that.$Loading.close()
that.sendMsg("获取数据失败")
})
},
choice(index){
this.trade_type = index;
window.localStorage.setItem('trade_type',this.trade_type)
this.getData()

},

sendMsg(content) {
this.msg = content;
this.show = true;
},
},

}



// WEBPACK FOOTER //
// ./src/pages/index.vue